import React from "react";

export const MessagesTabHeader: React.FC = () => {
    return <>Messages</>;
};
